import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/IssuePriorityController/CreateIssuePriorityController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateContractRates({ issue, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ PriorityName: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (issue) {
            setFormData({ PriorityName: issue.PriorityName });
        } else {
            setFormData({ PriorityName: '' }); // Clear form data when switching to add mode
        }
    }, [issue]);
    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (issue) {
            formData.ID = issue.ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };
    const handleFileChange = (event) => {
        const file = event.target.files[0];
    
        if (file) {
            const img = new Image();
            const objectUrl = URL.createObjectURL(file);
    
            img.onload = () => {
                if (img.width <= 35 && img.height <= 35) {
                    setFormData(prevState => ({
                        ...prevState,
                        File: file,
                        Path: file.name
                    }));
                    setErrors(prevErrors => ({
                        ...prevErrors,
                        Path: null
                    }));
                } else {
                    setFormData(prevState => ({
                        ...prevState,
                        File: null,
                        Path: ''
                    }));
                    setErrors(prevErrors => ({
                        ...prevErrors,
                        Path: 'Image dimensions must be 35px by 35px or smaller.'
                    }));
                }
                URL.revokeObjectURL(objectUrl); // Clean up
            };
    
            img.onerror = () => {
                setErrors(prevErrors => ({
                    ...prevErrors,
                    Path: 'Invalid image file.'
                }));
                URL.revokeObjectURL(objectUrl); // Clean up
            };
    
            img.src = objectUrl;
        } else {
            setFormData(prevState => ({
                ...prevState,
                File: null,
                Path: ''
            }));
        }
    };
    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="issuePriorityModal" tabIndex="-1" aria-labelledby="issuePriorityModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{issue ? "Edit Priority" : "Add Priority"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">

                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Priority Name:<span style={{ "color": "red" }}>*</span></label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="PriorityName" value={formData.PriorityName} onChange={handleFieldChange} />
                                        {errors.PriorityName && <div style={{ color: 'red' }}>{errors.PriorityName}</div>}
                                    </div>

                                </div>
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px" }}>
                                    <label htmlFor="Path" className="col-sm-2 col-form-label">Choose Icon</label>
                                    <div className="col-sm-4">
                                        <input type="file" className="form-control file-control" name="File" onChange={handleFileChange} />
                                        {errors.Path && <div style={{ color: 'red' }}>{errors.Path}</div>}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {issue ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

        </div>
    );
}

export default CreateContractRates;